import * as queryString from 'query-string';

const parameters = queryString.parse(window.location.search);

const API = parameters.api_url || process.env.REACT_APP_API_URL || 'https://api.qa.corva.ai';
const DATA_API = process.env.REACT_APP_DATA_API_URL || API.replace('api', 'data');

export const CORVA_API_URLS = {
  API,
  DATA_API,
};
